import { createAction } from 'redux-actions';
import { get, put, del, post } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf';
import { identity } from 'lodash';
import session from 'lib/session';

export const actions = {
  disable: del`integrations/:type`(identity),
  fetch: get`integrations/:type`(identity),
  fetchYotpo: get`integrations/yotpo`(identity),
  fetchStamped: get`integrations/stamped`(identity),
  updateStamped: put`integrations/stamped`(identity),
  updateYotpo: put`integrations/yotpo`(identity),
  enableStamped: createAction('plugins.enableStamped'),
  enableYotpo: createAction('plugins.enableYotpo'),
};

export const reducer = createReducer(void 0, {
  [actions.fetchYotpo]: (s, { payload }) => ({ ...s, yotpo: payload }),
  [actions.fetchStamped]: (s, { payload }) => ({ ...s, stamped: payload }),
  [actions.enableStamped]: (s) => ({
    ...s,
    stamped: { ...s.stamped, enabled: true },
  }),
  [actions.enableYotpo]: (s) => ({
    ...s,
    yotpo: { ...s.yotpo, enabled: true },
  }),
  [actions.disable]: (s, { payload }) => ({
    ...s,
    yotpo: { ...s.yotpo, enabled: false },
    stamped: { ...s.stamped, enabled: false },
  }),
});

export { default as saga } from './sagas';
